"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var QuestionMark = function QuestionMark(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M48 88c22.091 0 40-17.909 40-40S70.091 8 48 8 8 25.909 8 48s17.909 40 40 40zm0 8C21.49 96 0 74.51 0 48S21.49 0 48 0s48 21.49 48 48-21.49 48-48 48z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M51.79 59.08h-8.716a192.172 192.172 0 0 1-.034-2.29c0-2.825.467-5.15 1.4-6.973.935-1.823 2.804-3.873 5.606-6.152 2.803-2.279 4.478-3.771 5.025-4.477.843-1.117 1.264-2.347 1.264-3.692 0-1.868-.746-3.47-2.238-4.802-1.493-1.333-3.504-2-6.033-2-2.438 0-4.478.695-6.118 2.085-1.64 1.39-2.769 3.51-3.384 6.358l-8.818-1.094c.25-4.079 1.988-7.542 5.212-10.39 3.224-2.849 7.457-4.273 12.698-4.273 5.514 0 9.9 1.441 13.159 4.324 3.258 2.882 4.888 6.237 4.888 10.066 0 2.119-.598 4.124-1.795 6.015-1.196 1.891-3.754 4.466-7.673 7.725-2.028 1.686-3.287 3.042-3.777 4.067-.49 1.026-.712 2.86-.666 5.503zM43.074 72v-9.604h9.604V72h-9.604z"
  }))));
};
var _default = exports.default = QuestionMark;